import { CI_Container, CI_Name, CI_Progress, courseItemVariants } from "./CourseItem.styled";
import { ServiceName } from "../../../../../../../constants";
import { GrandChartCourseStore } from "../../../../../../../stores/grand-charts/grand-chart-course.store";
import { Header } from "./Header";
import { CircleProgress } from "../../../../../CircleProgress";
import { observer } from "mobx-react";
import { calculatePercent } from "../../../../../../../helpers";
import { useStores } from "../../../../../../../stores";
import { getColorByService } from "../../../../../../../styles";
import { AnimatePresence } from "framer-motion";
import { useEffect, useState } from "react";

interface CourseItemProps {
	isActive: boolean;
	service: ServiceName;
	index: number;
	grandChartCourse: GrandChartCourseStore;
}

export const CourseItem = observer(({ isActive, service, index, grandChartCourse }: CourseItemProps) => {
	const { statisticsStore } = useStores();
	const [showProgress, setShowProgress] = useState(false);

	const currentPassedSecond = statisticsStore.getByCourseId(grandChartCourse.id);
	const currentPassedProgress = calculatePercent(grandChartCourse.total_second, currentPassedSecond);
	const delayProgress = 900 + index * 120;

	useEffect(() => {
		const timer = window.setTimeout(() => {
			setShowProgress(true);
		}, delayProgress);
		return () => window.clearTimeout(timer);
	}, [delayProgress]);

	return (
		<CI_Container $service={service} $isActive={isActive} variants={courseItemVariants}>
			<Header service={service} sort={grandChartCourse.sort} />
			<CI_Name>{grandChartCourse.course.name}</CI_Name>

			<AnimatePresence>
				{showProgress && (
					<CI_Progress>
						<CircleProgress
							value={currentPassedProgress}
							strokeWidth={2}
							size={40}
							colorProgress={getColorByService(service)}
						/>
					</CI_Progress>
				)}
			</AnimatePresence>
		</CI_Container>
	);
});
